import React from 'react';
import Switch from 'react-switch';
import {
  NameBox,
  NameCard,
  Heading,
  DetailsCard,
  ContactText,
  FullLine,
  ParentLine,
  UserDetailsBox,
  Infocard,
  Label,
  Status,
  FormBox,
  DetailsBox,
  SwitchCard,
  FormButtonBox,
  CancelButton,
  SaveButton,
  ContactBox,
  ErrorMessage,
  SelectErrorMessage,
  InfocardPrimary,
  SavingIndicator,
  SelectComp,
} from './users-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '@app/styles';
import { Select, Input, Button, Uploader } from '@app/components';
import { useForm } from 'react-hook-form';
import { SelectOption, UserInfo, UserRoles, UserTypes } from '@app/types';
import {
  useGetActiveMunicipalitiesQuery,
  useCreateNewUserQuery,
} from '@app/graphql';
import { Star } from '@app/components/input/input-components';

const defaultOption = {
  label: 'Please select...',
  value: '',
};

const defaulRoletOption = {
  label: 'Please select...',
  value: '',
  key: '',
};

type MunicipalityOption = SelectOption & any;

type UserTypeProps = {
  label: string;
  value: string;
  key: string;
};
type UserProps = {
  type: UserTypeProps;
  firstName: string;
  lastName: string;
  company?: SelectOption;
  municipality: SelectOption;
  email: string;
  phone?: string;
  image?: string;
  firebaseId?: string;
};

type Props = {
  onCancelUserClick: () => void;
  userDetails?: UserInfo;
  onUserSubmit: (userDetails: any) => void;
  userTypes: UserTypes[];
  titleCompanies: SelectOption[];
};

const UsersForm = (props: Props) => {
  const { register, errors, handleSubmit, formState } = useForm();
  const { isSubmitted } = formState;
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const [getActiveMunicipalties] = useGetActiveMunicipalitiesQuery();
  const [CreateUser] = useCreateNewUserQuery();
  const [municipalityList, setMunicipalityList] = React.useState<
    MunicipalityOption[]
  >([]);
  const [showUserTypeDropdown, setShowUserTypeDropdown] = React.useState({
    show: false,
    typeData: [],
    label: '',
  });
  const [checked, setChecked] = React.useState<boolean>(true);
  const [emailError, setEmailError] = React.useState('');
  const [fileName, setFileName] = React.useState<string>('');
  const [saving, updatesaving] = React.useState<boolean>(false);
  const [phone, setPhone] = React.useState('');
  const [userRole, setUserRole] = React.useState(defaulRoletOption);
  const [userData, setUserData] = React.useState<UserProps>({
    type: { label: 'Please Select', value: '', key: '' },
    firstName: '',
    lastName: '',
    company: defaultOption,
    municipality: defaultOption,
    email: '',
    phone: '',
    image: '',
    firebaseId: '',
  });

  React.useEffect(() => {
    getActiveMunicipalties({
      variables: { stateId: '6214c9ab4b40aa5f023cd33e' },
    })
      .then((data: any) => {
        if (data && data.data) {
          const { getActiveMunicipalitiesByState } = data.data;
          const { municipality, success } = getActiveMunicipalitiesByState;
          if (success && municipality && municipality.length) {
            const municipalityOptions = municipality.map(
              (mun: MunicipalityOption) => {
                return {
                  label: mun.name,
                  value: mun.id,
                  ...mun,
                };
              },
            );
            setMunicipalityList(municipalityOptions);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (props.userDetails) {
      const {
        firstName = '',
        lastName = '',
        email = '',
        titleCompanyId = '',
        phone = '',
        firebaseId = '',
        profilePicUrl = '',
        userType = '',
        municipalityId = '',
        status = '',
      } = props.userDetails;
      const selectedUserType = props.userTypes.filter(
        u =>
          u.value === userType.toLowerCase() ||
          u.key === userType.toLowerCase(),
      );
      const selectedCompany = props.titleCompanies.filter(
        u => u.value === titleCompanyId,
      );
      const selectedMunicipality = municipalityList.length
        ? municipalityList.filter(m => m.value === municipalityId)
        : [];

      setUserData({
        firstName: firstName,
        lastName: lastName,
        company:
          selectedCompany && selectedCompany.length
            ? selectedCompany[0]
            : defaultOption, // company,
        phone: phone,
        email: email,
        image: profilePicUrl,
        firebaseId: firebaseId,
        municipality: {
          label: selectedMunicipality.length
            ? selectedMunicipality[0].label
            : 'Please Select',
          value: selectedMunicipality.length
            ? selectedMunicipality[0].value
            : '',
        },
        type: {
          label:
            selectedUserType && selectedUserType.length
              ? selectedUserType[0].label
              : 'please select',
          key:
            selectedUserType && selectedUserType.length
              ? selectedUserType[0].key
              : '',
          value: selectedUserType.length ? selectedUserType[0].value : '',
        },
      });
      if (props.userDetails && props.userDetails.roleData) {
        const { roleData } = props.userDetails;
        formRoleData(roleData, userType);
      }
      setPhone(phone);
      setFileName(profilePicUrl);
      setChecked(status === 'ACTIVE');
    }
    // eslint-disable-next-line
  }, [props.userDetails, municipalityList]);

  const onChange = (event: any, type?: string) => {
    const { name: fieldName, value: fieldValue } =
      (event && event.target) || '';
    if (type === 'userType') {
      setUserRole(defaulRoletOption);
      if (event.key && event.key === 'admin_user') {
        setUserRole({
          label:
            event.userRoles &&
            event.userRoles.length &&
            event.userRoles[0].name,
          value:
            event.userRoles && event.userRoles.length && event.userRoles[0]._id,
          key:
            event.userRoles && event.userRoles.length && event.userRoles[0].key,
        });
      }
      if (
        event.key &&
        (event.key === 'professional_user' || event.key === 'municipality_user')
      ) {
        setShowUserTypeDropdown({
          show: true,
          typeData: event.userRoles
            ? event.userRoles.map((uType: any) => {
                return { ...uType, label: uType.name, value: uType._id };
              })
            : [],
          label: 'User Role',
        });
      } else {
        setShowUserTypeDropdown({ show: false, typeData: [], label: '' });
      }
      setUserData({ ...userData, type: event });
    } else if (type === 'municipality') {
      setUserData({ ...userData, municipality: event });
    } else if (fieldName === 'firstname') {
      setUserData({ ...userData, firstName: fieldValue });
    } else if (fieldName === 'lastname') {
      setUserData({ ...userData, lastName: fieldValue });
    } else if (type === 'titleCompany') {
      setUserData({ ...userData, company: event });
    } else if (fieldName === 'email') {
      setUserData({ ...userData, email: fieldValue });
    } else if (type === 'subUserType') {
      setUserRole(event);
    }
  };

  /**
   *
   * @param roleData role date of selected user
   * @param userType user type of selected user
   */
  const formRoleData = (roleData: any, userType: string) => {
    setUserRole({
      label: roleData.name ? roleData.name : '',
      value: roleData._id ? roleData._id : '',
      key: roleData.key ? roleData.key : '',
    });
    const options =
      props.userTypes && props.userTypes.length
        ? props.userTypes.filter((option: UserTypes) => {
            return option.key === userType.toLowerCase();
          })
        : [];
    let userRoleOptions: any = [];
    if (options && options.length) {
      let roles = options[0].userRoles;
      userRoleOptions =
        roles && roles.length
          ? roles.map((role: UserRoles) => {
              return { ...role, label: role.name, value: role._id };
            })
          : [];
    }
    setShowUserTypeDropdown({
      show: true,
      typeData:
        userRoleOptions && userRoleOptions.length ? userRoleOptions : [],
      label: 'User Role',
    });
  };

  const onPhoneChange = (event: any) => {
    setPhone(event);
  };
  const onImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setFileName(event.target.files[0].name);
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setUserData({ ...userData, image: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  const onDeleteImage = () => {
    setFileName('');
    setUserData({ ...userData, image: '' });
  };
  const onSubmit = () => {
    updatesaving(true);
    const userVariables = {
      userTypeId: userData.type.value,
      userType: userData.type.key ? userData.type.key : userData.type.label,
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      phone: phone,
      profilePicUrl: userData.image,
      status: checked ? 'ACTIVE' : 'INACTIVE',
      userRoleId: userRole.value,
    };
    if (userData.type.key === 'municipality_user') {
      Object.assign(userVariables, {
        municipalityId: userData.municipality.value,
      });
    } else if (userRole.key === 'titleAgent_professional_user') {
      Object.assign(userVariables, {
        titleCompanyId: userData.company?.value,
        titleCompany: userData.company?.label,
      });
    }
    if (!userData.firebaseId) {
      Object.assign(userVariables, {
        action: 'add',
      });
    } else {
      Object.assign(userVariables, {
        firebaseId: userData.firebaseId,
      });
    }
    CreateUser({
      variables: userVariables,
    })
      .then((res: any) => {
        updatesaving(false);
        const { createNewUserAccount = {} } = res.data;
        const { success = true } = createNewUserAccount;
        if (success) {
          const { user = {} } = createNewUserAccount;
          props.onUserSubmit({
            type: !userData.firebaseId ? 'add' : 'edit',
            user: user,
          });
        } else {
          const { message = '' } = createNewUserAccount;
          if (message === 'user is already exists in db.') {
            setEmailError('Email already exists');
          }
        }
      })
      .catch((err: any) => {
        updatesaving(false);
      });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <NameBox>
        <NameCard>
          <Heading>
            {userData.firebaseId ? 'Edit User' : 'Add New User'}
          </Heading>
        </NameCard>
        <FormButtonBox>
          {saving && (
            <SavingIndicator>
              <FontAwesomeIcon
                color={primaryColor}
                icon={faCircleNotch}
                size="lg"
                spin
              />
            </SavingIndicator>
          )}
          <CancelButton disabled={saving}>
            <Button
              variant="text"
              size="medium"
              onClick={() => {
                props.onCancelUserClick();
              }}>
              Cancel
            </Button>
          </CancelButton>
          <SaveButton disabled={saving}>
            <Button variant="primary" size="medium" width="100%" type="submit">
              Save
            </Button>
          </SaveButton>
        </FormButtonBox>
      </NameBox>
      <DetailsCard>
        <ContactBox>
          <ContactText>Contact Details</ContactText>
          <Status>
            <SwitchCard>
              <Switch
                onChange={() => {
                  setChecked(!checked);
                }}
                checked={checked}
                onColor="#D1D7FA"
                onHandleColor="#4D5DC7"
                offHandleColor="#4D5DC7"
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 5px 10px rgba(13 18 51/ 10%)"
                activeBoxShadow="0px 5px 10px rgba(78 96 196/ 10%)"
                height={14}
                width={40}
                className="react-switch"
                id="material-switch"
              />
            </SwitchCard>
            <Label>{checked ? 'Active' : 'Inactive'}</Label>
          </Status>
        </ContactBox>
        <ParentLine>
          <FullLine />
        </ParentLine>
      </DetailsCard>
      <UserDetailsBox>
        <DetailsBox>
          <InfocardPrimary>
            <SelectComp>
              <Label>User Type</Label>
              <Star>*</Star>
            </SelectComp>
            <Select
              options={props.userTypes}
              placeholder="Please Select"
              value={userData.type}
              onChange={e => onChange(e, 'userType')}
              register={register({ required: true, name: 'userType' })}
            />
            {isSubmitted && !userData.type.value && (
              <SelectErrorMessage>Please select User Type</SelectErrorMessage>
            )}
          </InfocardPrimary>
          {showUserTypeDropdown.show && (
            <InfocardPrimary>
              <SelectComp>
                <Label>{showUserTypeDropdown.label}</Label>
                <Star>*</Star>
              </SelectComp>
              <Select
                options={showUserTypeDropdown.typeData}
                placeholder="Please Select"
                value={userRole}
                onChange={e => onChange(e, 'subUserType')}
                register={register({
                  required: true,
                  name: 'professionalUserType',
                })}
              />
              {isSubmitted && !userRole.value && (
                <SelectErrorMessage>
                  Please select Professional User Type
                </SelectErrorMessage>
              )}
            </InfocardPrimary>
          )}
        </DetailsBox>
        <DetailsBox style={{ marginTop: '0px' }}>
          <Infocard>
            <Input
              star="*"
              label="First Name"
              placeholder="Enter First Name"
              name="firstname"
              value={userData.firstName}
              onChange={onChange}
              register={register({ required: true })}
            />
            {errors.firstname && (
              <ErrorMessage>Please enter First Name</ErrorMessage>
            )}
          </Infocard>
          <Infocard>
            <Input
              placeholder="Enter Last Name"
              name="lastname"
              star="*"
              label="Last Name"
              value={userData.lastName}
              onChange={onChange}
              register={register({ required: true })}
            />
            {errors.lastname && (
              <ErrorMessage>Please enter Last Name</ErrorMessage>
            )}
          </Infocard>
        </DetailsBox>
        <FormBox>
          <Infocard>
            <Input
              star="*"
              label="Email"
              disabled={userData.firebaseId ? true : false}
              placeholder="Enter Email"
              name="email"
              value={userData.email}
              onChange={onChange}
              register={register({
                required: true,
                pattern: emailPattern,
              })}
            />
            {errors.email && errors.email.type === 'required' && (
              <ErrorMessage>Please enter Email</ErrorMessage>
            )}
            {errors.email && errors.email.type === 'pattern' && (
              <ErrorMessage>Please enter valid Email</ErrorMessage>
            )}
            {!errors.email && emailError && (
              <ErrorMessage>{emailError}</ErrorMessage>
            )}
          </Infocard>
          {(userRole.key === 'titleAgent_professional_user' ||
            userData.company?.value) && (
            <Infocard>
              <SelectComp>
                <Label>Company</Label>
                <Star>*</Star>
              </SelectComp>
              <Select
                placeholder="Select Company"
                options={props.titleCompanies}
                value={userData.company}
                onChange={(e: any) => onChange(e, 'titleCompany')}
                register={register({ required: true, name: 'titleCompany' })}
              />
            </Infocard>
          )}
          {userData.type.key === 'municipality_user' && (
            <Infocard>
              <Label>Municipality</Label>
              <Select
                options={municipalityList}
                placeholder="Please Select"
                value={userData.municipality}
                onChange={e => onChange(e, 'municipality')}
                register={register({ name: 'municipality' })}
              />
            </Infocard>
          )}
        </FormBox>
        <FormBox>
          <Infocard>
            <Label>Phone Number</Label>
            <Input
              placeholder="Enter Phone Number"
              type="phone_number"
              name="phone"
              value={phone}
              onChange={(e: any) => onPhoneChange(e)}
              register={register({})}
            />
          </Infocard>
        </FormBox>
        <FormBox>
          <Infocard>
            <Uploader
              label="Profile Pic"
              onChange={e => {
                onImageChange(e);
              }}
              fileName={fileName}
              chooseText="Choose Pic"
              profileImage={userData.image}
              borderRadius="8px"
              onImageDelete={onDeleteImage}
            />
          </Infocard>
        </FormBox>
      </UserDetailsBox>
    </form>
  );
};

export default UsersForm;
